/*
 * Public API Surface of dynamic-script-injector
 */

export * from './lib/services/dynamic-script-injector.service';
export * from './lib/dynamic-script-injector.module';
